import { useState } from 'react';
import { DailySearchForm } from '../types';
import { validateUserId, validateDate, formatDateToString } from '../utils';

export const useDailyForm = (initialForm?: DailySearchForm) => {
  const [form, setForm] = useState<DailySearchForm>(
    initialForm || {
      userId: '',
      selectedDate: '',
    }
  );
  
  const [errors, setErrors] = useState<Partial<DailySearchForm>>({});

  const handleUserIdChange = (value: string) => {
    const sanitizedValue = value.replace(/\D/g, '');
    setForm(prev => ({ ...prev, userId: sanitizedValue }));
    if (errors.userId) {
      setErrors(prev => ({ ...prev, userId: undefined }));
    }
  };

  const handleSelectedDateChange = (date: Date | null) => {
    const dateString = date ? formatDateToString(date) : '';
    setForm(prev => ({ ...prev, selectedDate: dateString }));
    if (errors.selectedDate) {
      setErrors(prev => ({ ...prev, selectedDate: undefined }));
    }
  };

  const validate = (): boolean => {
    const newErrors: Partial<DailySearchForm> = {};

    if (!form.userId) {
      newErrors.userId = 'ユーザIDを入力してください';
    } else if (!validateUserId(form.userId)) {
      newErrors.userId = '有効なユーザIDを入力してください';
    }

    if (!form.selectedDate) {
      newErrors.selectedDate = '計測日を選択してください';
    } else if (!validateDate(form.selectedDate)) {
      newErrors.selectedDate = '有効な日付を入力してください';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return {
    form,
    errors,
    handleUserIdChange,
    handleSelectedDateChange,
    validate,
  };
};
